<script>
    import DocumentTable from "../../../common/DocumentTable.svelte";

    let tableDanos = [
        {
            'slug': 'licencia-conducir',
            'label': 'Fotocopia licencia de conducir del conductor',
            'archivo': ''
        },
        {
            'slug': 'croquis',
            'label': 'Croquis e informe de accidente de tránsito diligenciado por la autoridad competente',
            'archivo': ''
        },
        {
            'slug': 'licencia-transito',
            'label': 'Fotocopia de licencia de tránsito (Matrícula o Tarjeta de Propiedad)',
            'archivo': ''
        },

        {
            'slug': 'otro',
            'label': 'Otro',
            'archivo': ''
        }
    ]

    let tableHurtos = [
        {
            'slug': 'denuncia-penal',
            'label': 'Denuncia penal instaurada ante autoridad competente',
            'archivo': ''
        },
        {
            'slug': 'licencia-conducir',
            'label': 'Fotocopia licencia de conducir del conductor',
            'archivo': ''
        },
        {
            'slug': 'licencia-transito',
            'label': 'Fotocopia de licencia de tránsito (Matrícula o Tarjeta de Propiedad)',
            'archivo': ''
        },

        {
            'slug': 'otro',
            'label': 'Otro',
            'archivo': ''
        }
    ]

</script>

<div class="back-gray p-1 radius">
    Por favor <strong>adjunte los documentos de soporte</strong> necesarios para poder formalizar su reclamación
</div>
<div class="my-2">
    <p class="primary mb-1">Documentos adjuntos sobre daños</p>
    <DocumentTable data="{tableDanos}" archivoLabel="Nombre documento" actionsLabel="" checkbox="{false}"/>
</div>
<div class="my-2">
    <p class="primary mb-1">Documentos adjuntos sobre hurtos</p>
    <DocumentTable data="{tableHurtos}" archivoLabel="Nombre documento" actionsLabel="" checkbox="{false}"/>
</div>